import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'organizedUnit/All', method: 'GET', body: null, token: token })
}
